import { Action, Mutation, getModule, Module, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import {ResponseDataType} from "@/form/form.types";
import {IPartner} from "@/entity/partner/partner.types";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import { IStoreReady } from '@/store/lib/storeSupport'

@Module({
    namespaced: true,
    name: 'partner',
    store,
    dynamic: true,
})
class PartnerModule extends VuexModule implements IStoreReady{
    partner: IPartner[] = [];
    partnerLoading = false;
    ready = false

    @Mutation
    async clearItems() {
        this.partner=[];
    }
    
    @Mutation
    async setReady(st:boolean){
        this.ready = st
    }

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ partner: IPartner[]; partnerLoading: boolean }> {
        const partner = await store.$repository.partner.fetchAll(data);
        let partnerLoading = false;
        if (partner.length > 0) {
            partnerLoading = true;
        }
        return {partner, partnerLoading};
    }
    @Action({rawError: true})
    async delete(id: number): Promise<ResponseDataType> {
        return  await store.$repository.partner.delete({id: id});
    }
}

export const PartnerStore = getModule(PartnerModule);
